webpackJsonp([112079914871742],{

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _list = __webpack_require__(46);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _services = __webpack_require__(27);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _shutterstock_ = __webpack_require__(58);
	
	var _shutterstock_2 = _interopRequireDefault(_shutterstock_);
	
	var _balance_logo = __webpack_require__(225);
	
	var _balance_logo2 = _interopRequireDefault(_balance_logo);
	
	var _banner = __webpack_require__(22);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BusinessValuation = function BusinessValuation(props) {
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(_banner2.default, {
	      title: 'Unternehmensbewertung',
	      image: _shutterstock_2.default
	    }),
	    _react2.default.createElement(_list2.default, {
	      text: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Gutachten zur Bewertung von Unternehmen, Unternehmensteilen oder Gesellschaftsanteilen nach anerkannten Unternehmens\xADbewertungs\xADverfahren (z.B. Institut der Wirtschaftspr\xFCfer IDW S1)'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Beratung und Begeleitung beim Kauf oder Verkauf von Unternehmen, Unternehmensteilen oder Gesellschaftsanteilen'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Bewertung f\xFCr Zwecke der Erbschaft- oder Schenkungsteuer nach dem Vereinfachten Ertragswertverfahren gem. \xA7\xA0199 Bewertungsgesetz'
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'p',
	          null,
	          'F\xFCr weitergehende Fragen k\xF6nnen Sie uns gerne ansprechen.'
	        )
	      ),
	      icon: _balance_logo2.default
	    }),
	    _react2.default.createElement(_services2.default, {
	      taxAdvice: true,
	      businessAdvice: true,
	      servicesInCooperation: true,
	      accounting: true,
	      businessValuation: false
	    })
	  );
	};
	
	exports.default = BusinessValuation;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-unternehmensbewertung-js-fd56a4a9737b269d77c3.js